import React, { useMemo, useEffect } from 'react';
import {
  Card,
  CardContent,
  CircularProgress,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import PageLayout from '../../components/layout/PageLayout';
import { useGetPaymentSummaryQuery } from '../../store/api';
import { toast } from 'react-toastify';

const formatTotal = (v) => {
  if (v === undefined || v === null || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return `$${v}`;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export default function GeneratePaymentSummary() {
  const { data, isLoading: loading, error } = useGetPaymentSummaryQuery();

  const rows = useMemo(() => {
    const list = data?.data ?? data?.list ?? (Array.isArray(data) ? data : []);
    return Array.isArray(list) ? list : [];
  }, [data]);

  useEffect(() => {
    if (error) toast.error(error?.data?.message || 'Failed to load payment summary');
  }, [error]);

  return (
    <PageLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
           Payment Summary
        </Typography>

        <Card>
          <CardContent sx={{ p: 0 }}>
            <TableContainer component={Paper} elevation={0}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'grey.100' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Month</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>Amount</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>Received</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>Refund</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>Remaining</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>Revenue</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                        <Typography color="text.secondary">No data returned for this report.</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, idx) => (
                      <TableRow key={`${row.month}-${idx}`} hover>
                        <TableCell>{row.month ?? '—'}</TableCell>
                        <TableCell align="right">{formatTotal(row.amount)}</TableCell>
                        <TableCell align="right">{formatTotal(row.received)}</TableCell>
                        <TableCell align="right">{formatTotal(row.refund)}</TableCell>
                        <TableCell align="right">{formatTotal(row.remaining)}</TableCell>
                        <TableCell align="right">{formatTotal(row.revenue)}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
    </PageLayout>
  );
}
